import { useQuery } from '@tanstack/react-query'
import {
	type GetFinalReviewListingsParams,
	httpGetFinalReviewListings
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const FINAL_REVIEW_LISTINGS_QUERY_KEY = 'final-review-listings'

export const useGetFinalReviewListings = (
	params: GetFinalReviewListingsParams = {}
) =>
	useQuery({
		queryKey: [FINAL_REVIEW_LISTINGS_QUERY_KEY, params],
		queryFn: () => httpGetFinalReviewListings(params)
	})
